import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { useI18n } from "../hooks/useI18n";
import { useBusinessPageData } from "../hooks/useBusinessPageData";
import OrganizationNotFound from "../components/organization/OrganizationNotFound";
import type { OrganizationPageData } from "../presentation/organizations/organizationPage.types";

interface BusinessLayoutProps {
  children: React.ReactNode | ((business: OrganizationPageData) => React.ReactNode);
}

const BusinessLayout: React.FC<BusinessLayoutProps> = ({ children }) => {
  const { businessId } = useParams<{ businessId: string }>();
  const location = useLocation();
  const { text } = useI18n();
  const { businesses, getBusinessById } = useBusinessPageData();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [businessId, location.pathname]);

  const business = getBusinessById(businessId || "");

  if (!business) {
    return (
      <div className="flex min-h-screen flex-col">
        <Navbar businesses={businesses} />
        <main className="flex flex-grow items-center justify-center">
          <OrganizationNotFound title={text.business.notFound} description={text.business.notFoundBody} />
        </main>
        <Footer showContact={false} />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar businesses={businesses} currentBusiness={business} />
      <main className="flex-grow pt-16">
        {typeof children === "function" ? children(business) : children}
      </main>
      <Footer showContact={false} />
    </div>
  );
};

export default BusinessLayout;
